import Pagination from './Pagination';
export default Pagination;
//# sourceMappingURL=index.js.map
